const getAddress = () => {
  try {
    const btn = document.querySelector('.cart-customer-form').querySelector('.get-postal');
    
    btn.addEventListener('click', function(){
      AjaxZip3.zip2addr('customer[zipcode]','','customer[pref]','customer[address1]','customer[address2]');
    });
    
  } catch (error) {
    //console.log(error);
  }

  try {
    const btn = document.querySelector('.cart-form-delivery').querySelector('.get-postal');
    
    btn.addEventListener('click', function(){
      AjaxZip3.zip2addr('delivery[zipcode]','','delivery[pref]','delivery[address1]','delivery[address2]');
    });
    
  } catch (error) {
    //console.log(error);
  }

  const joss_stick_postal = document.querySelector('.get-postal-josstick');
  if(joss_stick_postal) {
    joss_stick_postal.addEventListener('click', function() {
      AjaxZip3.zip2addr('custom_customer[joss_stick_postal]','','custom_customer[joss_stick_pref]','custom_customer[joss_stick_address1]','custom_customer[joss_stick_address2]');
    });
  }
}

export default  getAddress